import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toSeconds'
})

export class ToSecondsPipe implements PipeTransform {
  transform(ms: number): string {
    if (isNaN(ms) || ms <= 0) {
      ms = 0;
    }

    return `${(ms / 1000).toFixed(3)}s`;
  }
}
